module.exports = __webpack_public_path__ + "static/media/abex.49e9f7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/abex.png
// module id = 129
// module chunks = 0